jQuery( ( $ ) => {
	let utmSource = window.TOOLS.getUrlParams( 'utm_source' );
	utmSource = utmSource.split('#')[0];

	const toolkitContent = {

		content:
			'<p>Success. You’re on your way to discovering how the right PEO partnership can help you deliver greater value as an advisor, boost your earnings and transform your business. Check your inbox for direct access to the toolkit resources or click below to view each resource online.</p>',
		resources: {
			benefit: {
				url:'https://www.insperity.com/hr-solutions/wp-content/uploads/sites/3/DTL-W1123-5431_DTL-New-Improved-Insperity-Guide-to-Employee-Benefits-Magazine-DIGITAL-FINAL.pdf',
			},
			brokerage: {
				url:'https://www.insperity.com/hr-solutions/wp-content/uploads/sites/3/SCP-1124-5272_Broker-Campaign-Channel-Update-Flyer-FINAL.pdf',
			},
			outsourcing: {
				url:'https://www.insperity.com/hr-solutions/wp-content/uploads/sites/3/DWU-W0424-1822_DWU-step-by-step-guide-to-HR-outsourcing-Update-ebook.pdf',
			},
			peo: {
				url:'https://www.insperity.com/blog/infographic-what-can-a-peo-do-for-your-business/',
			},
		},

	};


	const resource = toolkitContent.resources;


	if ( $( '.fastTrackContainerP' ).length ) {
		if ( 'success' === utmSource ) {
			$( '.fastTrackContainerP' ).html( `${ toolkitContent.content }` );

		}
	}

	if ( 'success' === utmSource ) {
		$( '#headerBtn' )
			.html( 'Access Now' )
			.removeClass( 'btn-primary' )
			.addClass( 'btn-secondary' );

		$('#headerBtn').removeAttr('data-toggle');
		$('#headerBtn').attr('href','#completeBrokerPowerPack');

		$('.fastTrackCol1').css('margin-bottom', '51px');
		$('.toolkit-header-img img').css('margin-top', '50px');

		$('.power-pack-btn').remove();

		$('#resource1').append(`<a data-file-content="Magazine" href="${ resource.benefit.url }" target="_blank" class="btn btn-secondary mt-5 benefits">Access Now</a>`);
		$('#resource2').append(`<a data-file-content="Case Study" href="${ resource.brokerage.url }" target="_blank" class="btn btn-secondary brokerage">Access Now</a>`);
		$('#resource3').append(`<a data-file-content="E-book" href="${ resource.outsourcing.url }" target="_blank" class="btn btn-secondary outsourcing" style="margin-top: 4.5rem;">Access Now</a>`);
		$('#resource4').append(`<a href="${ resource.peo.url }" target="_blank" class="btn btn-secondary mt-5 peo ">Access Now</a>`);

	}


});
